const steps = [
  {
    number: "01",
    icon: "ri-search-eye-line",
    title: "Site Assessment",
    desc: "Our engineers conduct a thorough on-site survey — measuring spaces, assessing heat loads, reviewing existing infrastructure, and identifying the optimal HVAC solution for your building.",
    image: "/images/design/as-built.webp",
  },
  {
    number: "02",
    icon: "ri-draft-line",
    title: "Engineering Design",
    desc: "We produce detailed 2D and 3D design drawings, airflow calculations, equipment schedules, and energy efficiency reports — all fully compliant with Kenyan building codes.",
    image: "/images/design/floor-plan.webp",
  },
  {
    number: "03",
    icon: "ri-tools-line",
    title: "Fabrication & Supply",
    desc: "Ductwork is fabricated in-house at our Nairobi workshop. Equipment is sourced from leading global brands and delivered ready for installation on your project schedule.",
    image: "/images/hvac/ductwork.webp",
  },
  {
    number: "04",
    icon: "ri-settings-3-line",
    title: "Installation & Commissioning",
    desc: "Our certified installation teams work to strict timelines. On completion, every system is fully commissioned, tested, and handed over with as-built drawings and user training.",
    image: "/images/hvac/ahu.webp",
  },
];

export default function HvacProcess() {
  return (
    <section id="process" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-teal-600 text-xs font-semibold uppercase tracking-widest mb-3 block">How It Works</span>
          <h2 className="text-gray-900 text-4xl md:text-5xl font-extrabold uppercase tracking-tight">
            Our Process
          </h2>
          <p className="text-gray-500 text-sm mt-4 max-w-xl mx-auto leading-relaxed">
            A proven 4-step methodology that guarantees every HVAC system we deliver performs to specification from day one.
          </p>
        </div>

        {/* Steps */}
        <div className="space-y-16">
          {steps.map((step, i) => (
            <div
              key={step.number}
              className={`grid grid-cols-1 lg:grid-cols-2 gap-10 items-center ${i % 2 === 1 ? "lg:flex-row-reverse" : ""}`}
            >
              {/* Image */}
              <div className={`relative ${i % 2 === 1 ? "lg:order-2" : ""}`}>
                <div className="w-full h-72 rounded-lg overflow-hidden">
                  <img
                    src={step.image}
                    alt={step.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="absolute -top-4 -left-4 w-12 h-12 flex items-center justify-center bg-teal-600 rounded-lg">
                  <span className="text-white font-extrabold text-sm">{step.number}</span>
                </div>
              </div>

              {/* Content */}
              <div className={i % 2 === 1 ? "lg:order-1" : ""}>
                <div className="w-12 h-12 flex items-center justify-center bg-teal-50 rounded-lg mb-5">
                  <i className={`${step.icon} text-xl text-teal-600`}></i>
                </div>
                <h3 className="text-gray-900 text-2xl font-extrabold uppercase tracking-tight mb-3">
                  {step.title}
                </h3>
                <p className="text-gray-500 text-sm leading-relaxed">
                  {step.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
